import axios from "axios"

export const getUserLocationAndClendlyUrl = () => {
    return axios.get(process.env.REACT_APP_API_EVAL_URL + 'getConfig');
}